"use client"

import {useQuery} from "@tanstack/react-query";
import {pendingJobKeys} from "@/hooks/queries/queryKeys";
import {pendingJobsAPI} from "@/app/apiPaths";
import {jr} from "@/hooks/queries/response-handler";
import {ListPendingJobsResponse} from "@/pb/api/devplan/services/web/company";
import {useMemo} from "react";

export function usePendingJobs(companyId: number | undefined) {
  const {data, ...rest} = useQuery({
    queryKey: pendingJobKeys.all(companyId!),
    queryFn: () => fetch(pendingJobsAPI(companyId!)).then(jr).then(ListPendingJobsResponse.fromJSON),
    enabled: !!companyId,
    refetchInterval: (query) => {
      const jobs = query.state.data?.jobs ?? [];
      const hasActive = jobs.some(j => j.status === "pending");
      return hasActive ? 5_000 : 30_000;
    },
  });

  const jobs = useMemo(() => data?.jobs ?? [], [data]);
  const hasActiveJobs = useMemo(() => jobs.some(j => j.status === "pending"), [jobs]);

  return {jobs, hasActiveJobs, ...rest};
}
